module.exports = "<div class=\"modal-header\">\r\n  <h3 class=\"modal-title\" id=\"modal-title\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i> {{$ctrl.title}}</h3>\r\n</div>\r\n<div class=\"modal-body\" id=\"modal-body\">\r\n  <dl class=\"dl-horizontal\">\r\n    <dt ng-repeat-start=\"field in $ctrl.fields\">{{field.name}}</dt>\r\n    <dd ng-repeat-end=\"\">{{field.data}}</dd>\r\n  </dl>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/components/detail-list-modal/detail-list-modal.component.html
// module id = 987
// module chunks = 0